import DIRECTION_OFFSETS from '_data/puzzleDirections';
import { canInsertDiagonal } from './validate';
import { finalizeWordPlacement } from './finalize';
import { getRandomCoordinates } from './coords';

export function selectDiagonalDirection(
  wordsPlacedQuantity,
  isAllDiagonalEnabled,
  isReversedDiagonalStrategy,
) {
  const normalDiagonalDirections = ['down-right', 'down-left'];
  const reversedDiagonalDirections = ['up-left', 'up-right'];

  if (isAllDiagonalEnabled) {
    const allDiagonalDirections = [
      ...normalDiagonalDirections,
      ...reversedDiagonalDirections,
    ];
    return allDiagonalDirections[
      wordsPlacedQuantity % allDiagonalDirections.length
    ];
  }

  if (isReversedDiagonalStrategy) {
    return reversedDiagonalDirections[
      wordsPlacedQuantity % reversedDiagonalDirections.length
    ];
  }

  return normalDiagonalDirections[
    wordsPlacedQuantity % normalDiagonalDirections.length
  ];
}

export function insertDiagonal(engine, word, direction, game, attempts = 0) {
  const { rows, columns } = engine.model;

  if (attempts > engine.maxInsertAttempts) {
    engine.state.registerFailure(word, direction);
    engine.state.addUnplaced(word);
    return false;
  }

  const { row, col } = getRandomCoordinates(rows, columns);

  if (!canInsertDiagonal(engine, word, row, col, direction, game.table)) {
    return insertDiagonal(engine, word, direction, game, attempts + 1);
  }

  const offset = DIRECTION_OFFSETS[direction];

  for (let i = 0; i < word.length; i += 1) {
    const r = row + offset.row * i;
    const c = col + offset.col * i;
    const idx = r * columns + c;
    game.table[idx].text = word[i];
  }

  finalizeWordPlacement(engine, game, word, row, col, direction);
  return true;
}
